<template>
  <div>
    <b><span>Comparativo de dados:</span></b>
    <br><br>
    <v-data-table :headers="headers" :items="itens" item-key="id" />
  </div>
</template>

<script>
  export default {
      props: {
        refresh: Function,
        analises: Array
      },
      data() {
      return {
        headers: [
          { text: 'Dado', value: 'dadoComparacao' },
          { text: 'Preenchido', value: 'dadoPreenchido' },
          { text: 'Consultado', value: 'dadoConsultado' },
          { text: 'Comparativo', value: 'comparativoBureau' },
        ],
        itens: [],
        indicadorComparativo: null
      }
      },
      methods: {
        alimentarObjeto() {
          const th = this
          th.itens= []
          if(th.analises.length == 0)
            return;
  
          th.itens = JSON.parse(JSON.stringify(th.analises));
          th.itens.forEach(curr => th.normalizarCampos(curr))
        },
        normalizarCampos(curr){
          const th = this
          
          curr.dadoPreenchido = curr.dadoPreenchido ? curr.dadoPreenchido.toUpperCase() : curr.dadoPreenchido;
          curr.dadoConsultado = curr.dadoConsultado ? curr.dadoConsultado.toUpperCase() : curr.dadoConsultado;

          if (curr.dadoComparacao === 'Data de nascimento' || curr.dadoComparacao === 'Data de abertura') {
            curr.dadoPreenchido = th.$api.UI.Format.Date(curr.dadoPreenchido)
            curr.dadoConsultado = th.$api.UI.Format.Date(curr.dadoConsultado)
          }

          curr.comparativoBureau === 1 ? th.indicadorComparativo = '🟢 ' : th.indicadorComparativo = '🔴 ' 
          curr.comparativoBureau = th.indicadorComparativo + th.$api.Arrays.ComparativoBureau.find((x) => x.value == curr.comparativoBureau).text
        }
      }
  }
  </script>
    